export default "__VITE_ASSET__BMTlgKOS__"